import state from './state'
import _ from 'lodash'

import { DraggablePlaceholder } from '../../util/DragAndDrop'
import PaginationHelper from '../../util/PaginationHelper'
import StoreHelper from '../helper'
import PositionManager from '../../util/PositionManager'

const helper = {
  registerDragElement: (viewName, el, index) => {
    if (_.includes(StoreHelper.getDragElements(viewName), el)) return

    el.draggable = true

    state.drag.elementsViewMap[viewName] = state.drag.elementsViewMap[viewName] || []
    state.drag.elementsViewMap[viewName].splice(index, 0, el)
  },

  registerDropTarget: (el) => {
    if (_.includes(state.drop.targets, el)) return

    state.drop.targets.push(el)
  },

  unregisterDropTarget: (el) => {
    state.drop.targets = _.filter(state.drop.targets, dt => dt !== el)
  },

  // setter
  setDraggingElement: (viewName, el) => {
    state.drag.element = el
    state.drag.startIndex = helper.getDragElementIndex(viewName, el)
  },

  setDraggingElementValue: (value) => {
    state.drag.elementValue = _.cloneDeep(value)
  },

  setDropTarget: (el) => {
    state.drop.target = el
  },

  setTouchDropTarget: (el) => {
    state.touch.dropTarget = el
  },

  // getter
  getDropTargets: () => {
    return _.get(state.drop, 'targets', [])
  },

  getTouchDropTarget: () => {
    return _.get(state.touch, 'dropTarget', null)
  },

  getDragElements (viewName = null) {
    if (_.isNull(viewName)) return state.drag.elementsViewMap
    return _.get(state.drag.elementsViewMap, viewName, [])
  },

  getDragElementsWithoutPlaceholder: (viewName = null) => {
    const _viewName = viewName || StoreHelper.getActiveViewKey()
    return _.filter(helper.getDragElements(_viewName), de => !_.isEqual(de, DraggablePlaceholder))
  },

  getDraggingElementValue: () => {
    return _.get(state.drag, 'elementValue', null)
  },

  getDragStartIndex: () => {
    return _.get(state.drag, 'startIndex', null)
  },

  getDragElement: () => {
    return _.get(state.drag, 'element', null)
  },

  getDropTarget: () => {
    return _.get(state.drop, 'target', null)
  },

  getDropTargetIndex: (el, limited = false) => {
    const index = _.findIndex(helper.getDropTargets(), el)
    const items = helper.getDragElementsWithoutPlaceholder()
    const nextPossibleDropPosition = PaginationHelper.getItemsByPage(items, StoreHelper.getPaginationPage()).length

    return limited ? Math.min(index, nextPossibleDropPosition) : index
  },

  getDropIndicatorIndex: () => {
    return helper.isDropTargetDefined()
      ? helper.getDropTargetIndex(helper.getDropTarget(), true)
      : helper.getDragStartIndex()
  },

  getDragElementIndex: (viewName, el) => {
    return _.findIndex(helper.getDragElements(viewName), el)
  },

  // helper
  isDragInProgress: () => {
    return !!helper.getDragElement()
  },

  isDropTarget: (el) => {
    return _.isEqual(helper.getDropTarget(), el)
  },

  isAfterDropTarget: (index) => {
    if (!helper.isDropTargetDefined()) return false

    return _.gt(index, helper.getDropTargetIndex(helper.getDropTarget()))
  },

  isDropTargetDefined: () => {
    return !!helper.getDropTarget()
  },

  isTouchDropTarget: (el) => {
    return _.isEqual(helper.getTouchDropTarget(), el)
  },

  addDragElement: (viewName, el, index) => {
    el.draggable = true
    state.drag.elementsViewMap[viewName].splice(index, 0, el)

    PositionManager.recalculateDragElementPositions(state.drag.elementsViewMap[viewName])
    PaginationHelper.redefineElementsVisibility(state.drag.elementsViewMap[viewName])
  },

  removeDragElement: (viewName, el) => {
    _.remove(state.drag.elementsViewMap[viewName], element => _.isEqual(element, el))

    PositionManager.recalculateDragElementPositions(state.drag.elementsViewMap[viewName])
    setTimeout(() => {
      PaginationHelper.redefineElementsVisibility(state.drag.elementsViewMap[viewName])
    }, 500)
  },

  resetSoft: () => {
    state.drag.startIndex = null
    state.drag.element = null
    state.drag.elementValue = null

    state.drop.target = null
  }
}

export default helper
